module.exports = __webpack_public_path__ + "static/media/Magearna_gaussian2.27ad3b60.png";